import React from 'react';
import { useTranslation } from 'react-i18next';
import PredictionCard from './PredictionCard';

function PredictionList({ predictions, type, oddsFormat, isFavorite, onToggleFavorite }) {
  const { t } = useTranslation('dashboard');

  if (!predictions || predictions.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 rounded-full bg-anthracite-800 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="text-gray-400 text-lg mb-2">{t('noPredictions')}</div>
        <p className="text-gray-600 text-sm">{t('noPredictionsHint')}</p>
      </div>
    );
  }

  return (
    <div className="prediction-list rounded-xl border border-anthracite-700 overflow-hidden bg-anthracite-900">
      {/* Header row - Desktop only */}
      <div className="hidden md:flex items-center px-4 py-2 gap-4 bg-anthracite-800 border-b border-anthracite-700 text-xs text-gray-500 uppercase tracking-wider">
        {onToggleFavorite && <div className="w-6 flex-shrink-0"></div>}
        <div className="w-24 flex-shrink-0">{t('status')}</div>
        <div className="flex-1 min-w-0">{t('match')}</div>
        <div className="w-16 text-center flex-shrink-0">{t('score')}</div>
        <div className="flex items-center gap-3 flex-shrink-0">
          {type === 'btts' ? (
            <>
              <div className="w-[52px] text-center">{t('grade')}</div>
              <div className="w-[52px] text-center">{t('odds')}</div>
            </>
          ) : type === 'ai_picks' ? (
            <>
              <div className="w-[52px] text-center">{t('grade')}</div>
              <div className="w-[60px] text-center">{t('pick')}</div>
              <div className="w-[52px] text-center">{t('conv')}</div>
              <div className="w-[52px] text-center">{t('odds')}</div>
            </>
          ) : (
            <>
              <div className="w-[52px] text-center">{t('grade')}</div>
              <div className="w-[52px] text-center">{t('pick')}</div>
              <div className="w-[52px] text-center">{t('odds')}</div>
            </>
          )}
        </div>
        <div className="w-6 flex-shrink-0"></div>
      </div>

      {/* Prediction rows */}
      {predictions.map((prediction, index) => (
        <PredictionCard
          key={prediction.id || index}
          prediction={prediction}
          type={prediction._originalType || type}
          oddsFormat={oddsFormat}
          isFavorite={isFavorite ? isFavorite(prediction.id, prediction._originalType || type) : false}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
}

export default PredictionList;
